import { render } from "./TheBuoy.vue?vue&type=template&id=e80a7dce&scoped=true&ts=true"
import script from "./TheBuoy.vue?vue&type=script&lang=ts"
export * from "./TheBuoy.vue?vue&type=script&lang=ts"

import "./TheBuoy.vue?vue&type=style&index=0&id=e80a7dce&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80a7dce"]])

export default __exports__